import { Link } from 'react-router-dom';

export function NotFound() {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center">
      <h1 className="page-title" style={{ fontSize: 64 }}>404</h1>
      <p className="mt-2 text-sm" style={{ color: 'var(--color-text-3)', fontFamily: 'var(--font-mono)', letterSpacing: '0.1em' }}>PAGE NOT FOUND</p>
      <Link
        to="/"
        className="btn-primary mt-4 rounded-md px-4 py-2 text-sm font-medium"
      >
        Back to To do
      </Link>
    </div>
  );
}
